import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Output, EventEmitter } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-select-check-all',
    templateUrl: "./select-check-all.component.html",
    styleUrls: ['./select-check-all.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SelectCheckAllComponent {
  @Input() model: FormControl;
  @Input() values = [];
  @Input() text = 'All'; 
  @Output() allCheckboxEvent = new EventEmitter<string>();
  isChecked(): boolean {
    return this.model.value && this.values.length
      && this.model.value.length === this.values.length;
  }

  isIndeterminate(): boolean {
    return this.model.value && this.values.length && this.model.value.length
      && this.model.value.length < this.values.length;
  }

  toggleSelection(change: MatCheckboxChange): void {
    if (change.checked) {
      this.model.setValue(this.values);
      this.allCheckboxEvent.emit("true");
    } else {
      this.model.setValue([]);
      this.allCheckboxEvent.emit("false");
    }
  }
}
